import {
  createFetchClient,
  type FetchClient,
} from "@fluid-app/checkout-api-client";
import { env } from "@/env";
import Cookies from "js-cookie";

function getCheckoutApiBaseUrl() {
  return env.NEXT_PUBLIC_FLUID_API_URL.replace(/\/api\/?$/, "");
}

const checkoutApiDefaultHeaders = { "x-fluid-client": "checkout" };

function handleCheckoutAuthError() {
  if (!Cookies.get("jwt")) return;

  Cookies.remove("jwt");
  window.location.reload();
}

export function createCheckoutApiClient(jwt?: string | null): FetchClient {
  return createFetchClient({
    baseUrl: getCheckoutApiBaseUrl(),
    getAuthToken: () => jwt ?? Cookies.get("jwt") ?? null,
    defaultHeaders: checkoutApiDefaultHeaders,
    onAuthError: handleCheckoutAuthError,
  });
}

export function createPublicCheckoutApiClient(): FetchClient {
  return createFetchClient({
    baseUrl: getCheckoutApiBaseUrl(),
    defaultHeaders: checkoutApiDefaultHeaders,
  });
}
